module.exports = __webpack_public_path__ + "img/rosepetal-dep-flexicap-baxter.54f7ad06.jpg";